// import { RUN_ENVIORNMENT } from '../misc/config';

const getClientId = API_URL => {
  let CLIENT_ID = null;
  // if (RUN_ENVIORNMENT) {
  //   CLIENT_ID = 'f1s8ddnyvboelbm5vtmpleq66glqm2l13e9hrxgm';
  // } else {
  CLIENT_ID = '9i5gfoc8jlr5sfi4xv0fks5ukclco64yo9f4xrch';
  // }
  return CLIENT_ID;
};

export default getClientId;
